import { render } from "./newsLetter.vue?vue&type=template&id=b2130550"
import script from "./newsLetter.vue?vue&type=script&lang=js"
export * from "./newsLetter.vue?vue&type=script&lang=js"

import "./newsLetter.vue?vue&type=style&index=0&id=b2130550&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__